import styled from "styled-components";

export const RankDisplayStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  svg {
    width: 32px;
    height: auto;
  }

  .rank_plain {
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
    padding-left: 4px;
  }
`;
